import Meetings from '@/services/Meetings';
import { errorLog } from '@/utils/logger';

export default {
  setMeetings: ({ commit }, meetings) => commit('SET_MEETINGS', meetings),

  handleFetchMeetings: async ({
    commit,
    rootState: {
      dashboard: {
        calendar: { selectedDay },
      },
    },
  }) => {
    commit('SET_LOADING_MEETINGS', true);
    try {
      const response = await Meetings.fetchMeetingsByDay(selectedDay);

      commit('SET_MEETINGS', response?.data?.object || []);
    } catch (err) {
      errorLog(err);
    }

    commit('SET_LOADING_MEETINGS', false);
  },

  createMeeting: ({ commit, dispatch }, param) => {
    return Meetings.createMeeting(param)
      .then(response => {
        dispatch('handleFetchMeetings');
        return Promise.resolve(response);
      })
      .catch(err => {
        errorLog(err);
        alert(
          'Houve um erro ao marcar o atendimento' + err?.response?.data.msg,
        );
        return Promise.reject(err);
      });
  },

  rescheduleMeeting: ({ commit, dispatch }, param) => {
    return Meetings.rescheduleMeeting(param)
      .then(response => {
        dispatch('handleFetchMeetings');
        return Promise.resolve(response);
      })
      .catch(err => {
        errorLog(err);
        alert(
          'Houve um erro ao reagendar o atendimento: ' +
            err?.response?.data.msg,
        );
        return Promise.reject(err);
      });
  },

  cancelMeeting: async (
    { commit, dispatch, state: { appointmentToBeCancelled } },
    reason,
  ) => {
    try {
      await Meetings.cancelMeeting([appointmentToBeCancelled, reason]);
      dispatch('handleFetchMeetings');
      return Promise.resolve(true);
    } catch (err) {
      errorLog(err);
      alert(
        'Houve um erro ao cancelar o atendimento: ' + err?.response?.data.msg,
      );
      return Promise.reject(err);
    }
  },

  setThisAppointment: ({ commit }, appointment) => {
    commit('SET_APPOINTMENT', appointment);
  },

  cancelThisAppointment: ({ commit }, appointment) => {
    commit('CANCEL_APPOINTMENT', appointment);
  },
};
